import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { ActionCard } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/actionCard/ActionCard'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { AdminCard, AdminPageLayout } from './components/AdminPageLayout'
import { ADMIN_NP_PROGRAM } from '../common/constants/routingConstants'
import { hasRole } from '../common/utils/utils'
import { getAuthRoles } from '../data/auth/authSelectors'

type AdminProgram = {
  id: string
  title: string
  route: string
  roles: string[]
}

// To add an admin program: add its route (with its roles) in routingConstants, a <Route> in App.tsx, and an entry here.
const ADMIN_PROGRAMS: AdminProgram[] = [
  { id: 'np-program', title: 'NP Program Admin', route: ADMIN_NP_PROGRAM.route, roles: ADMIN_NP_PROGRAM.roles },
]

const AdminHome: FunctionComponent = () => {
  const navigate = useNavigate()
  const roles = useSelector(getAuthRoles)
  const programs = ADMIN_PROGRAMS.filter((program) => hasRole(roles, program.roles))

  return (
    <AdminPageLayout title='Admin' subtitle='Internal tools for managing programs.' testID={tID('AdminHome')}>
      <AdminCard title='Programs' description='Select a program to manage.'>
        {programs.map(({ id, title, route }) => (
          <ActionCard
            key={id}
            id={`AdminHome-${id}`}
            title={title}
            onPress={() => navigate(route)}
            customStyle={{ marginTop: 0 }}
          />
        ))}
        {programs.length === 0 && <BodyText text='No programs are available for your role.' />}
      </AdminCard>
    </AdminPageLayout>
  )
}

export default AdminHome
